import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "../utils/baseApi";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const getGames = () => {
  const apiKey = localStorage.getItem("apiKey");
  return axios.get(`${API_URL}/games`, {
    headers: {
      "x-api-key": apiKey,
    },
  });
};

const getGamesByPagination = (params = {}) => {
  const apiKey = localStorage.getItem("apiKey");

  return axios.get(`${API_URL}/games/pagination`, {
    params,
    headers: {
      "x-api-key": apiKey,
    },
  });
};

const createGame = (data) => {
  return axios.post(`${API_URL}/games`, data, { headers: authHeader() });
};

const updateGame = (id, data) => {
  return axios.put(`${API_URL}/games/${id}`, data, { headers: authHeader() });
};

const deleteGame = (id) => {
  return axios.delete(`${API_URL}/games/${id}`, { headers: authHeader() });
};

const playGameById = (id) => {
  const apiKey = localStorage.getItem("apiKey");
  return axios.get(`${API_URL}/games/want-to-play/${id}`, {
    headers: {
      "x-api-key": apiKey,
    },
  });
};

const gameService = {
  getGames,
  getGamesByPagination,
  createGame,
  updateGame,
  deleteGame,
  playGameById,
};

export default gameService;
